module.exports = __webpack_public_path__ + "static/img/union.739256dd.svg";